import {
    getCompanyList,
    setCompanyAdmin,
    getPersonList,
    setPersonAdmin,
    getCompanyConfig,
    getConsumeInfo,
    getEnableCustomFields,
} from '@/api/sys/company/company';
import { getCompanyPrize } from '@/api/sys/admin/company';
import { getTranslateWay } from '@/api/chat/translation';
import { getField, updateField } from '@/libs/vuexHelper';
// @ts-ignore
import { pkgLabels } from '@/views/main/setting/Fee/config/helper';
import { sessionSave, sessionRead } from '@/libs/util';

export default {
    namespaced: true,
    state: {
        companyList: [],
        activityStartTime: '0',
        activityEndTime: '0',
        browser_notice: false,
        weixin_notice: false,
        sound_notice: false,
        end_session_confirm: true,
        view_unassign: true, //! 默认值设置为true ,避免上次选中未分配，一进来未读取配置的情况下分配了会话
        chat_robot_wechat_push: false,
        chat_new_message_notice_switch: false,
        end_session_invite_evaluation: false,
        usageInfo: [],
        consume_info: {},
        baseInfo: {
            package: '',
        },
        chat_offline_default_channel: '3',
        client_message_notice: { // 客服端新消息提醒
            browser_tab_tips: '1',
        },
        auth_technology_status: '0', // '0' | '1' 是否授权技术人员访问
        check_whatsapp_protocol: '0', // '0' | '1' 消息广播 whatsapp 是否同意政策
        timeout_no_response_notification: {
            switch_status: '0',
            notification_type: '',
            notification_interval: {
                hour: 0,
                minute: 0,
            },
        },

        /** 牛信云外呼相关（废弃） start */
        nxCloudConfig: {
            status: '0',
        },
        nxccRef: null,
        isLoginByNXCloud: false,
        showNXCloudLoginModal: false,
        nxCloudComponentWidth: 84,
        /** 牛信云外呼相关（废弃） end */

        translate_way: '0', // 翻译线路
        actualTranslateWay: '0', // 实际翻译线路（包含大模型）
        email_translate_way: '0', // ai 邮箱翻译线路
        auto_ai_detect_language: '0', // 是否开启AI自动识别语言
        auto_ai_detect_language_time: '0', // 开启AI自动识别的时间(用来和会话创建时间做判断)

        // 当前开启的自定义字段列表
        enableCustomFieldsList: [],
        // 邀请评价限制单次评价
        invite_evaluation_limit: false,

        // 是否开启自动注销项目
        auto_remove_project: '0',
    },
    getters: {
        getField,
        allowTrial(state: any) {
            return state.baseInfo.trial_package === '1';
        },
    },
    mutations: {
        updateField,
        setCompanyList(state: any, list: any) {
            state.companyList = list;
        },
        setActivityTime(state: any, data: any) {
            const { activityStartTime, activityEndTime } = data;
            state.activityStartTime = activityStartTime;
            state.activityEndTime = activityEndTime;
        },
        setAuthTechnologyStatus(state: any, status: string) {
            state.auth_technology_status = status;
        },
        setCheckWhatsappProtocol(state: any, status: '0' | '1') {
            state.check_whatsapp_protocol = status;
        },
        setTranslateWay(state: any, translate_way: string) {
            state.translate_way = translate_way;
        },
        setEmailTranslateWay(state: any, email_translate_way: string) {
            state.email_translate_way = email_translate_way;
        },
        // 设置浏览器提示音
        setSoundNotice(state: any, status: boolean) {
            state.sound_notice = status;
        },
        // 浏览器通知
        setBrowserNotice(state: any, status: boolean) {
            state.browser_notice = status;
        },
        // 机器人托管消息提醒
        setChatRobotWechatPush(state: any, status: boolean) {
            state.chat_robot_wechat_push = status;
        },
        // 转人工/已分配会话消息提醒
        setChatNewMessageNoticeSwitch(state: any, status: boolean) {
            state.chat_new_message_notice_switch = status;
        },
        // 关闭会话二次确认
        setEndSessionConfirm(state: any, status: boolean) {
            state.end_session_confirm = status;
        },
        // 结束会话自动发起评价
        setEndSessionAutoInviteEvaluation(state: any, status: boolean) {
            state.end_session_invite_evaluation = status;
        },
        // 邀请评价限制单次评价
        setInviteEvaluationLimit(state: any, status: boolean) {
            state.invite_evaluation_limit = status;
        },
        // 聊天插件访客离线发消息默认渠道
        setChatOfflineDefaultChannel(state: any, channel: string) {
            state.chat_offline_default_channel = channel;
        },
        // 客服端新消息提醒
        setClientMessageNotice(state: any, data: any) {
            state.client_message_notice = data;
        },
        // 超时未回复通知
        setTimeoutNoResponseNotification(state: any, data: any) {
            state.timeout_no_response_notification = data;
        },
        setAutoAiDetectLanguage(state: any, status: string) {
            state.auto_ai_detect_language = status;
        },
        setAutoAiDetectLanguageTime(state: any, time: string) {
            state.auto_ai_detect_language_time = time;
        },
        setAutoRemoveProject(state: any, status: string) {
            state.auto_remove_project = status;
        },
    },
    actions: {
        // 更新开启的自定义字段列表
        fetchEnableCustomFields({ state }: any, suffix: string = '') {
            const localKey = `ENABLE_CUSTOM_FIELD_LIST_${suffix}`;
            if (suffix) {
                const result = sessionRead(localKey);
                if (result) {
                    // 两分钟缓存，避免频繁刷新
                    const timestamp = 60 * 1000 * 2;
                    const customFieldObj = JSON.parse(result);
                    if (new Date().getTime() - customFieldObj.timestamp < timestamp) {
                        state.enableCustomFieldsList = customFieldObj.result;
                        return customFieldObj.result;
                    }
                }
            }
            return getEnableCustomFields().then((res) => {
                const data = res.data.data;
                const list = Array.isArray(data) ? data : [];
                state.enableCustomFieldsList = list;
                if (suffix) {
                    const localData = {
                        timestamp: new Date().getTime(),
                        result: list,
                    };
                    sessionSave(localKey, JSON.stringify(localData));
                }
                return list;
            });
        },
        fetchConsume({ state }: any) {
            return getConsumeInfo().then((res) => {
                const data = res.data.data;

                const _usage: any[] = [];
                pkgLabels.forEach((k: string) => {
                    _usage.push({
                        key: k,
                        value: (data.consume_info as any)[k],
                        total: (data.package_info as any)[k],
                    });
                });

                state.usageInfo = _usage;
                state.baseInfo = {
                    ...data.project_info,
                    ...data.package_info,
                };
                state.consume_info = data.consume_info;
                return res;
            });
        },
        fetchActualTranslateWay({ state }: any) {
            return getTranslateWay().then((res: any) => {
                state.actualTranslateWay = res.data.data.translate_way;
            });
        },
        syncNotificationConfig({ state }: any) {
            getTranslateWay().then((res: any) => {
                state.actualTranslateWay = res.data.data.translate_way;
            });
            return getCompanyConfig([
                'browser_notice',
                'chat_wechat_notice_push',
                'sound_notice',
                'end_session_confirm',
                'chat_offline_default_channel',
                'chat_robot_wechat_push',
                'chat_new_message_notice_switch',
                'client_message_notice',
                'remote_technical_support',
                'view_unassign',
                'check_whatsapp_protocol',
                'timeout_no_response_notification',
                'translate_way',
                'end_session_invite_evaluation',
                'invite_evaluation_limit',
                'email_translate_way',
                'auto_ai_detect_language',
                'auto_ai_detect_language_time',
                'auto_remove_project',
            ]).then((res: any) => {
                const list = res.data.data.list;
                state.browser_notice = list.browser_notice === '1';
                state.weixin_notice = list.chat_wechat_notice_push === '1';
                state.chat_robot_wechat_push = list.chat_robot_wechat_push === '1';
                state.chat_new_message_notice_switch = list.chat_new_message_notice_switch === '1';
                state.sound_notice = list.sound_notice === '1';
                state.end_session_confirm = list.end_session_confirm === '1';
                state.end_session_invite_evaluation = list.end_session_invite_evaluation === '1';
                state.invite_evaluation_limit = list.invite_evaluation_limit === '1';
                state.view_unassign = list.view_unassign === '1';
                state.chat_offline_default_channel = list.chat_offline_default_channel;
                state.auth_technology_status = list.remote_technical_support;
                state.check_whatsapp_protocol = list.check_whatsapp_protocol;
                state.translate_way = list.translate_way;
                state.email_translate_way = list.email_translate_way;
                state.auto_ai_detect_language = list.auto_ai_detect_language;
                state.auto_ai_detect_language_time = list.auto_ai_detect_language_time;
                state.auto_remove_project = list.auto_remove_project;
                // 客服端新消息提醒
                if (list.client_message_notice) {
                    state.client_message_notice = JSON.parse(list.client_message_notice);
                }
                if (list.timeout_no_response_notification) {
                    state.timeout_no_response_notification = JSON.parse(list.timeout_no_response_notification);
                }
            }).catch(console.log);
        },
        postApplicationListAction({ rootState }: any, list: any[]) {
            return new Promise((resolve, reject) => {
                const arr: any = [];
                list.map((item: any) => {
                    const application = {
                        id: item.id,
                        unique_id: item.unique_id,
                        download_url: item.download_url,
                        status: item.status,
                    };
                    arr.push(application);
                    return item;
                });
            });
        },
        getCompanyList({ commit }: any, name?: string) {
            return getCompanyList(name).then((res: any) => {
                commit('setCompanyList', res.data.data.list);
            }).catch(() => {
                //
            });
        },
        setCompanyAdmin({ commit }: any, projectId: string) {
            return new Promise<void>((resolve, reject) => {
                setCompanyAdmin(projectId).then((res: any) => {
                    resolve();
                }).catch(() => {
                    //
                });
            });
        },
        getPersonList({ commit }: any, name?: string) {
            return getCompanyList(name).then((res: any) => {
                commit('setPersonList', res.data.data.list);
            }).catch(() => {
                //
            });
        },
        setPersonAdmin({ commit }: any, personId: string) {
            return new Promise<void>((resolve, reject) => {
                setPersonAdmin(personId).then((res: any) => {
                    resolve();
                }).catch(() => {
                    //
                });
            });
        },
        getCompanyPrize({ commit }: any, type?: string) {
            return new Promise((resolve, reject) => {
                getCompanyPrize(type).then((res: any) => {
                    resolve(res);
                }).catch((err: any) => {
                    reject(err);
                });
            });
        },
    },
};
